import http from './http';

import { GET_AD_ENDPOINT, UPDATE_AD_ENDPOINT } from './endpoints'

export default (() => {

    const getAd = () => http.get(GET_AD_ENDPOINT);

    const updateAd = params => http.put(UPDATE_AD_ENDPOINT, params);

    return {
        getAd,
        updateAd
    }
})();


// WEBPACK FOOTER //
// ./services/marketingAd.js